import { type RefObject, useEffect } from 'react';

type UseAutoSizeProps = {
    autoSize?: {
        minRows?: number;
        maxRows?: number;
    };
    ref: RefObject<HTMLTextAreaElement>;
    value?: string | number | readonly string[];
};

const TEXTAREA_PADDING = 24;
const BORDER_SIZING = 3;
const LINE_HEIGHT = 18.62;

const useAutoSize = ({ autoSize, ref, value }: UseAutoSizeProps) => {
    useEffect(() => {
        const adjustHeight = () => {
            const textarea = ref.current;
            if (!textarea || !autoSize) return;

            textarea.style.height = 'auto';

            const minHeight = autoSize.minRows
                ? `${Math.floor(autoSize.minRows * LINE_HEIGHT + TEXTAREA_PADDING + BORDER_SIZING)}px`
                : 'auto';
            const maxHeight = autoSize.maxRows
                ? `${Math.floor(autoSize.maxRows * LINE_HEIGHT + TEXTAREA_PADDING + BORDER_SIZING)}px`
                : 'none';

            textarea.style.minHeight = minHeight;
            textarea.style.maxHeight = maxHeight;
            textarea.style.height = `${textarea.scrollHeight + BORDER_SIZING}px`;
        };

        adjustHeight();
    }, [value, autoSize]);
};

export default useAutoSize;
